import { useEffect, useState, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import AdminNav from "../../components/AdminNav/AdminNav";
import '../../app.css'
import './Admin.css'

function Admin() {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(true);
    const [isHidden, setIsHidden] = useState(false);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {  
                setMenuOpen(false);
            } else {
                setMenuOpen(true);
            }
        };
        const handleScroll = () => {
            if (scrollContainerRef.current.scrollTop > 10 && window.innerWidth < 768) { 
                setIsHidden(true);
            } else {
                setIsHidden(false);
            }
        };
    
        const container = scrollContainerRef.current;
        container.addEventListener('scroll', handleScroll);

        window.addEventListener('resize', handleResize);

        handleResize();

        if (window.location.href.endsWith('/admin')) {
            navigate('/admin/animais/consulta');
        }

        return () => {
            window.removeEventListener('resize', handleResize);
            container.removeEventListener('scroll', handleScroll);
        };
    }, [navigate]);

    return (
        <div id="admin-wrapper" className={`font-mulish ${menuOpen ? "" : "menu-closed"} || ${isHidden ? "header-hidden" : ""}`}>
            <AdminNav menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
            <AdminHeader 
                menuOpen={menuOpen} 
                setMenuOpen={setMenuOpen} 
                isHidden={isHidden}
            />
            <div id="admin-content" className="w-full overflow-scroll" ref={scrollContainerRef}>
                <Outlet />
            </div>
        </div>
    );
}

export default Admin;
